import { ellipsis } from '@app/helpers/utils';
import { Tooltip } from '@mui/material';

const DEFAULT_TRUNCATE_LENGTH = 30;

type TruncatedTextWithTooltipProps = {
  value: string | null | undefined;
  /** Max visible characters before truncation. Defaults to 30. */
  length?: number;
};

/**
 * Renders text truncated to `length` characters. Shows a tooltip with the full
 * value only when the text is longer than the limit.
 */
export function TruncatedTextWithTooltip({
  value,
  length = DEFAULT_TRUNCATE_LENGTH,
}: TruncatedTextWithTooltipProps) {
  if (!value) {
    return null;
  }

  if (value.length <= length) {
    return <>{value}</>;
  }

  return (
    <Tooltip title={value} placement="top">
      <span>{ellipsis(value, length)}</span>
    </Tooltip>
  );
}
